import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormattedMessage } from 'react-intl';

import { settingsConfigurationService, localeService } from 'services';
import { errorTranslations } from 'translations';

export default class Recaptcha extends Component {
    constructor(props) {
        super(props);

        const nonceMeta = document.querySelector('meta[id="csp-nonce"]');

        this.state = {
            hasError: false,
            shouldReset: false,
            nonce: nonceMeta ? nonceMeta.getAttribute('content') : null,
        };

        this.component = React.createRef();
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    static getDerivedStateFromProps(nextProps) {
        return { shouldReset: nextProps.reset };
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.shouldReset && !prevState.shouldReset) {
            this.component.current.reset();
        }
    }

    render() {
        const { onChange, onExpired, className } = this.props;
        const { hasError, nonce } = this.state;

        const { googleRecaptchaKey } = settingsConfigurationService.get();
        const { lang } = localeService;

        if (hasError) {
            return <FormattedMessage {...errorTranslations.recaptchaError} />;
        }

        return (
            <ReCAPTCHA
                sitekey={googleRecaptchaKey}
                className={className}
                onChange={onChange}
                onExpired={onExpired}
                ref={this.component}
                hl={lang.cultureLanguageCode}
                scriptProps={nonce ? { nonce } : undefined}
            />
        );
    }
}

Recaptcha.propTypes = {
    className: PropTypes.object,
    reset: PropTypes.object,
    onChange: PropTypes.func,
    onExpired: PropTypes.func,
};
